import { createFileRoute } from "@tanstack/react-router";

import { EnrollmentFlowLayout } from "@layouts/enrollment-flow-layout";

export const Route = createFileRoute("/telus")({
  component: EnrollmentFlowLayout,
});
